/** @jsxImportSource @emotion/react */

import {
  CalciteInputMessage,
  CalciteLabel,
  CalciteSelect,
} from "@esri/calcite-components-react";
import React from "react";
import { SelectProps } from "./Select.d";

const Select: React.FC<SelectProps> = ({
  label,
  options,
  wrapperCss,
  children,
  value,
  scale = "m",
  labelSize = "m",
  onChange,
  message,
  disabled,
  copyable = true,
  ...remainingProps
}) => {
  return (
    <>
      <CalciteLabel
        css={wrapperCss}
        scale={labelSize}
        style={{
          cursor: copyable ? "pointer" : "default",
        }}
        onClick={
          copyable
            ? (e) => {
                e.stopPropagation();
                if (!value) return;
                navigator.clipboard.writeText(value || "");
              }
            : undefined
        }
      >
        <span
          onClick={
            copyable
              ? (e) => {
                  e.stopPropagation();
                  if (!value) return;
                  navigator.clipboard.writeText(value || "");
                }
              : undefined
          }
          style={{
            cursor: copyable ? "pointer" : "default",
          }}
        >
          {label}
        </span>
        <CalciteSelect
          scale={scale}
          label={label}
          value={value || ""}
          onCalciteSelectChange={onChange}
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          {...remainingProps}
        >
          {children}
        </CalciteSelect>
        {message && (
          <CalciteInputMessage
            status="valid"
            style={{ fontSize: "0.9em", opacity: 0.5 }}
          >
            {message}
          </CalciteInputMessage>
        )}
      </CalciteLabel>
    </>
  );
};

export default Select;
